<template>
  <div id="battle">
    <!-- <div class="page-banner0">
      <img class="bg-img" :src="banner.imgUrl">
    </div> -->
    <!-- <div class="crumbs hidden-xs-only"><router-link to="/">首页</router-link> >> 同心抗疫</div> -->
    <!-- <div id="battle_home">
      <h1 class="home-title">
        同心抗疫
        <span class="sub-title">伸出一双手 让爱心变希望</span>
      </h1>
      <div style="padding-bottom: 100px" v-html="described"></div>
      <div class="battle-tab">
        <a class="tab-item" :class="{active: v.colId == colId}" v-for="(v, i) in menu_list" :key="i" @click="tabHandle(v,i)">{{v.cnName}}</a>
      </div>
    </div> -->
    <div class="header-nav">
      <a class="tab-item" v-if="isPublicity"><span @click="toPage">同心抗疫</span> > <span style="cursor:default;">信息公示 ></span></a>
      <a class="tab-item" v-show="isPublicity" :class="{'active': i === pub_index}" v-for="(v, i) in publicity_list" :key="v.cnName" @click="handleTabpPub(v,i)">
          <!-- <span v-if="i != 0" style="color:#999999"> </span>  -->
          <span>{{v.cnName}}</span>
      </a>
      <a class="tab-item" :class="{active: v.colId == colId}" v-for="(v, i) in menu_list" :key="i" @click="tabHandle(v,i)">
        <!-- <span v-if="v.cnName==='抗疫故事'">{{v.cnName}}</span>
        <span v-if="!isPublicity&&v.cnName==='信息公示'">{{v.cnName}}</span> -->
        <span v-if="!isPublicity">{{v.cnName}}</span>   
      </a>
     
    </div>
    <div class="nav-wrap" :class="{'info-wrap': isPublicity}">
      <div class="nav-title">
        <span v-show="v.colId == colId" v-for="(v, i) in menu_list" :key="i">{{v.cnName}}</span>
      </div>
    </div>
    <!-- <div class="described" style="padding-bottom: 100px" v-html="described"></div> -->
    <div v-show="!isPublicity" class="list-wrap">
      <battle-list ref="newslist" :colid="colId"></battle-list>
    </div>
    <div v-show="isPublicity" class="pub-box">
      <file-list ref="fileList" :colid="colId"></file-list>
    </div>
  </div>
</template>

<script>
import {getColumns} from '@/api/home'
import BattleList from '../../components/BattleList.vue'
import FileList from '@/components/FileList'

export default {
  components: { BattleList,FileList },
  data() {
    return {
      banner: {
        imgUrl: ''
      },
      menu_list: [],
      described: '',
      colId: '',
      isPublicity:false,
      publicity_list:[],
      pub_index:0
    }
  },
  mounted() {
    this.$store.commit('setCurrentMenuI', 2)
    getColumns(this.$route.params.cid).then(res => {
      if (res) {
        this.described = res[0].described
        this.menu_list = res[0].subList
        if (!this.$route.params.aid) {
          if (res[0].subList.length > 0) {
            this.colId = res[0].subList[1].colId
            this.$router.replace(`/battle/${this.$route.params.cid}/${this.colId}`)
            // this.$refs.newslist.loadData(this.colId)
          }
        } else {
          this.colId = this.$route.params.aid
         
        }
        let _index = this.menu_list.findIndex(item => {
          return item.colId === this.colId
        })
        this.isPublicity = _index === 0
        if(_index === 0){
          getColumns(this.colId).then(res => {
            this.publicity_list = res[0].subList

            if(res[0].subList.length > 0)
              this.$refs.fileList.loadData(res[0].subList[0].colId)
          })
        }
        else if (_index == 1){
          //console.log("yes")
          this.$refs.newslist.loadData(this.colId)
        }

      }
    })
  },
  methods: {
    tabHandle(pData,index) {
      this.$router.push(`/battle/${this.$route.params.cid}/${pData.colId}`)
      this.colId = pData.colId
      this.isPublicity = index === 0
      if(index === 0){
        getColumns(this.colId).then(res => {
          this.publicity_list = res[0].subList
          if(res[0].subList.length > 0)
              this.$refs.fileList.loadData(res[0].subList[0].colId)
        })
      }
      else{
        this.$refs.newslist.loadData(this.colId)
      }
    },
    handleTabpPub(pData,index){
      this.pub_index = index
      this.$refs.fileList.loadData(pData.colId)
    },
    toPage () {
      this.$router.push(`/battle/1281628712452096/1281944140890112`)
      window.location.reload()
    }
  },
  watch: {
    $route: {
          handler() {
            if(!this.$route.params.aid) {
              window.location.reload()
            }
        },
        deep: true,
    }
  }
}
</script>

<style lang="scss" scoped>
  .list-wrap,.described {
    padding: 0 rem(75);
  }

  @media only screen and (min-width: 768px) {
    #battle_home,.pub-box {
      padding: 0 rem(75);
    }
    .nav-wrap {
      padding: 0 rem(135) 0 rem(75);
    }
    .info-wrap {
      padding: 0 rem(90) 0 rem(75);
    }
    .pub-item{
      font-size: rem(20);
      margin-bottom: rem(81);
    }
  }
  @media only screen and (max-width: 768px) {
    #battle_home,.pub-box {
      padding: 0 .575rem;
    }
    .pub-item{
      font-size: 0.24rem;
      margin-bottom: rem(95);
    }
    .header-nav {
      .tab-item {
        font-size: 13px;
        //margin-right: 15px;
      }
      .tab-item:nth-child(1){
        padding-right:0;
      }
    }
    .nav-wrap {
      margin-bottom: 20px;
    }
  }
  
  .pub-item{
    color: #999999;
  }
  .pub-active{
    color: #05459C;
  }
</style>
